import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { useComponentTheme } from '@chegg-ui/theme';
import { CaretIcon } from '@chegg-ui/horizon-icons';
import { getThemeConfig } from '@chegg-ui/input';
import { InputWrapper } from '@chegg-ui/input-wrapper';
import { NativeSelect } from '../styles';
export var NativeDropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      options = props.options,
      inputId = props.inputId,
      onSelectValue = props.onSelectValue,
      labelText = props.labelText,
      visuallyHideLabel = props.visuallyHideLabel,
      errorText = props.errorText,
      helperText = props.helperText,
      width = props.width,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      placeholder = props.placeholder,
      value = props.value,
      className = props.className,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      dataTest = props['data-test'],
      theme = props.theme,
      remainingSelectProps = _objectWithoutProperties(props, ["disabled", "options", "inputId", "onSelectValue", "labelText", "visuallyHideLabel", "errorText", "helperText", "width", "onFocus", "onBlur", "placeholder", "value", "className", "adjustToBackgroundColor", "data-test", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Input',
    theme: getThemeConfig(theme)
  });
  var a11yErrorLabel = errorText ? "".concat(inputId, "_error") : '';
  return /*#__PURE__*/React.createElement(InputWrapper, {
    inputId: inputId,
    labelText: labelText,
    visuallyHideLabel: visuallyHideLabel,
    errorText: errorText,
    helperText: helperText,
    width: width,
    className: className,
    disabled: disabled,
    adjustToBackgroundColor: adjustToBackgroundColor,
    trailingIcon: componentTheme.showCaretDownIcon ? /*#__PURE__*/React.createElement(CaretIcon, {
      pointing: "down"
    }) : /*#__PURE__*/React.createElement(ChevronIcon, null),
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(NativeSelect, _extends({
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: function onChange(e) {
      return onSelectValue(e.target.value);
    },
    placeholder: placeholder,
    value: value,
    hasTrailingIcon: true,
    id: inputId,
    ref: ref,
    "data-test": dataTest || inputId,
    customTheme: componentTheme,
    "aria-labelledby": "".concat(inputId, "_label ").concat(a11yErrorLabel)
  }, remainingSelectProps), function () {
    return options.map(function (optionValue) {
      return /*#__PURE__*/React.createElement("option", {
        key: optionValue,
        value: optionValue
      }, optionValue);
    });
  }()));
});
NativeDropdown.displayName = 'NativeDropdown';
export default NativeDropdown;